$("#close-popup, #continue-shopping, #addviewcart").click(function () {
    $("#addcartpopup").slideUp(500);
});

$("#checkout-button").click(function () {
    $(".checkouttext").text("");
    $(".progress-bar").css({"display":"inline-block"});
});

function openLightbox(src) {
    let imgsrc = src.getAttribute('data-arg1');
    document.getElementById("lightbox-img").src=imgsrc;
    document.getElementById("lightbox").style.display = "flex";
    lockScroll();
}

function closeLightbox() {
    document.getElementById("lightbox").style.display = "none";
    unlockScroll();
}

let scrollPosition = 0;

function lockScroll() {
    scrollPosition = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollPosition}px`;
    document.body.style.width = '100%';
}

function unlockScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollPosition);

}